var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-icon"},[(_vm.group)?_c('svg-loader',{attrs:{"title":_vm.group.label,"src":'/static/images/icon-notification-' + _vm.group.icon + '.svg'}}):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }